const dateTimeFilters = {
    date: function (value) {
        if (!value)
            return "";
        const stringValue = value.toString();
        const valDate = new Date(Date.parse(stringValue));
        const date = new Date(valDate).toLocaleDateString("cs-CZ");
        return `${date}`;
    },
    dateTimeRaw: function (value, separator) {
        if (!value)
            return "";
        if (!separator)
            separator = " ";
        value = value.toString();
        const valDate = new Date(Date.parse(value));
        const date = new Date(valDate).toLocaleDateString("cs-CZ");
        const time = new Date(valDate).toLocaleTimeString("cs-CZ");
        return `${date} ${separator} ${time}`;
    },
    dateTime: function (value, separator) {
        if (!value)
            return "";
        if (!separator)
            separator = " ";
        value = value.toString();
        const valDate = new Date(Date.parse(value));
        const date = new Date(valDate).toLocaleDateString("cs-CZ");
        const time = new Date(valDate).toLocaleTimeString("cs-CZ");
        return `<span class="font-weight-normal">${date}</span>${separator}<span class="ml-2 font-weight-light gray-text">${time}</span>`;
    },
    dateTimeMicro: function (value, separator) {
        if (!value)
            return "";
        if (!separator)
            separator = " ";
        value = value.toString();
        const array = value.split(".");
        const valDate = new Date(Date.parse(value));
        const date = new Date(valDate).toLocaleDateString("cs-CZ");
        const time = new Date(valDate);
        return `<span class="font-weight-normal">${date}</span>${separator}<span class="ml-2 font-weight-light gray-text">${time.toLocaleTimeString("cs-CZ")}.${array[1]?.slice(0, 3)}</span>`;
    },
    timestampToTime: function (value) {
        if (!value)
            return "";
        const valDate = new Date(value);
        const time = new Date(valDate).toLocaleTimeString("cs-CZ");
        return `${time}`;
    },
    timestampToDateTimeMicro: function (value, separator) {
        if (!value)
            return "";
        if (!separator)
            separator = " ";
        const valDate = new Date(value);
        const date = new Date(valDate).toLocaleDateString("cs-CZ");
        const time = new Date(valDate).toLocaleTimeString("cs-CZ");
        value = value / 1000;
        const stringValue = value.toString();
        const array = stringValue.split(".");
        return `<span class="font-weight-normal">${date}</span>${separator}<span class="ml-2 font-weight-light gray-text">${time}.${array[1]?.slice(0, 3)}</span>`;
    },
    timestampToDateTime: function (value) {
        if (!value)
            return "";
        const valDate = new Date(value * 1000);
        const date = valDate.toLocaleDateString("cs-CZ", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });
        const time = valDate.toLocaleTimeString("cs-CZ", {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        });
        return `${date} ${time}`;
    },
    time: function (value) {
        if (!value)
            return "";
        value = value.toString();
        const valDate = new Date(Date.parse(value));
        const time = new Date(valDate).toLocaleTimeString("cs-CZ");
        return `${time}`;
    },
};
export default dateTimeFilters;
